import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "E:/workspaces/shop-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//

/**
 * 产品详情
 */
import api from 'api/goodsDetail';
import { mapGetters } from 'vuex';
import { GET_SCREEN } from '$getters';
export default {
  name: 'module-detail',
  data: function data() {
    return {
      detailContent: '',
      descDetail: ''
    };
  },
  computed: _objectSpread({}, mapGetters({
    screen: GET_SCREEN
  })),
  watch: {
    '$route.query': {
      handler: function handler(val) {
        if (val && val['goodsId']) {
          this.selectDetailedContentByGoodsId(parseInt(val['goodsId']));
          this.selectMallGoodsInfo(parseInt(val['goodsId']));
        }
      },
      immediate: true
    }
  },
  methods: {
    selectDetailedContentByGoodsId: function selectDetailedContentByGoodsId(id) {
      var vm = this;
      var params = {
        goodsId: id
      };
      api.selectDetailedContentByGoodsId(params).then(function (res) {
        vm.detailContent = res.data;
      });
    },
    selectMallGoodsInfo: function selectMallGoodsInfo(id) {
      var vm = this;
      api.selectMallGoodsInfo({
        goodsId: id
      }).then(function (res) {
        if (res.data.descDetail) {
          vm.descDetail = res.data.descDetail;
        }
      });
    }
  }
};